import {get, trim} from 'lodash'
import {Basic} from 'types'
import {BookingQuestions} from '../types'

export const areRequiredFieldsFilled = (orderQuestions: BookingQuestions[], values: Basic.OrderActivityDetails) => {
  for (const bookingQuestion of orderQuestions) {
    for (const unitsQuestion of bookingQuestion.unitsQuestions) {
      for (const question of unitsQuestion.questions) {
        if (question.required && !trim(get(values, [bookingQuestion.bookingUuid, unitsQuestion.unitId, question.id]))) {
          return false
        }
      }
    }
  }

  return true
}
